import * as React from 'react';
import { SVGProps } from 'react';

const IconHealthSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zM7 7V4h2v3h3v2H9v3H7V9H4V7h3z"
    />
  </svg>
);
export default IconHealthSizeS;
